module.exports = __webpack_public_path__ + "static/media/advisor.dafbe9a1.svg";